<template>
  <div class="block lg:hidden">
    <nav class="flex gap-4 text-center" aria-label="Tabs">
      <ClientOnly>
        <NuxtLink
          v-for="item in navigation"
          :key="item.name"
          :to="item.href"
          :external="item.external"
          :target="item.external ? '_blank' : undefined"
          :class="[
            item.current
              ? 'bg-p-500 text-grey-900'
              : 'bg-transparent text-grey-100 hover:bg-grey-900 hover:text-white',
            'group w-full items-center rounded-md px-1 py-2 text-[9px] font-semibold transition-colors duration-200',
          ]"
          :aria-current="item.current ? 'page' : undefined"
          @click="emit('close')"
        >
          <Icon
            :name="item.icon"
            :class="[
              item.current
                ? 'text-grey-900'
                : 'text-grey-100 group-hover:text-white',
              'mx-auto block size-5 items-center transition-colors duration-200',
            ]"
            aria-hidden="true"
          />
          <span
            class="mt-1 flex items-center justify-center gap-1 text-paragraph-xxs"
          >
            {{ item.name }}
            <Icon
              v-if="item.external"
              name="share-03"
              class="size-3"
              aria-hidden="true"
            />
          </span>
        </NuxtLink>
      </ClientOnly>
    </nav>
  </div>
</template>

<script setup lang="ts">
import Icon from '~/components/common/Icon.vue'
import type { TTopbarNavigationItem } from '~/src/types/navigation'

defineProps<{ navigation: TTopbarNavigationItem[] }>()

const emit = defineEmits<{
  close: []
}>()
</script>
